export default "__VITE_ASSET__KIE0hfxa__"